import { history } from 'store/store';
export const Users = {
    TEACHER: 'teacher',
    STUDENT: 'student',
};
const teachersSignedOutPages = [
    '/teachers',
    '/teachers/',
    '/teachers/signup',
    '/teachers/signin',
    '/teachers/terms',
    '/teachers/privacy',
    '/teachers/terms/view',
    '/teachers/privacy/view',
];
const studentsSignedOutPages = [
    '/students',
    '/students/',
    '/students/signup',
    '/students/signin',
    '/students/terms',
    '/students/privacy',
];
export const isSns = () => {
    return history.location.pathname.includes('sns');
};
export const isStudentEditInfo = () => {
    return history.location.pathname.includes('/students/profile/edit/info');
};
export const isTeacherEditName = () => {
    return history.location.pathname.includes('/teachers/profile/edit/name');
};
export const isTeacherEditPicture = () => {
    return history.location.pathname.includes('/teachers/profile/edit/picture');
};
export const isTeachers = () => {
    return history.location.pathname.includes('teachers');
};
export const isStudents = () => {
    return history.location.pathname.includes('students');
};
export const getUserTypePath = () => {
    return isTeachers() ? 'teachers' : 'students';
};
export const getUserType = () => {
    return isTeachers() ? 'teacher' : 'student';
};
export const isTop = () => {
    const pathname = history.location.pathname;
    return pathname === '/';
};
export const isSignedOutPage = () => {
    const pathname = history.location.pathname;
    return (isTop() ||
        teachersSignedOutPages.includes(pathname) ||
        studentsSignedOutPages.includes(pathname));
};
export const shouldMoveToTeachersMyPage = () => {
    const pathname = history.location.pathname;
    if (isPasswordResetPage() || isPrivacyPage()) {
        return false;
    }
    return teachersSignedOutPages.includes(pathname);
};
export const shouldMoveToStudentsMyPage = () => {
    const pathname = history.location.pathname;
    if (isPasswordResetPage() || isPrivacyPage()) {
        return false;
    }
    return studentsSignedOutPages.includes(pathname);
};
export const isPasswordResetPage = () => {
    const pathname = history.location.pathname;
    return pathname.includes('password_');
};
export const isPrivacyPage = () => {
    const pathname = history.location.pathname;
    return pathname.includes('privacy');
};
export const isTermsPage = () => {
    const pathname = history.location.pathname;
    return pathname.includes('terms');
};
export const isConversationPage = () => {
    const pathname = history.location.pathname;
    return /\/conversations\/\d+$/.test(pathname);
};
export const isConversationEndPage = () => {
    const pathname = history.location.pathname;
    return /\/conversations\/\d+\/end$/.test(pathname);
};
export const isConversationEvaluatePage = () => {
    const pathname = history.location.pathname;
    return /\/conversations\/\d+\/evaluate$/.test(pathname);
};
export const isUnsupportedPage = () => {
    const pathname = history.location.pathname;
    return pathname.includes('unsupported');
};
export const isPickUpTag = () => {
    var _a;
    const query = new URLSearchParams(history.location.search);
    return (_a = query.get('type')) === null || _a === void 0 ? void 0 : _a.includes('pickup_tags');
};
